import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LoginPage from "@/pages/Login";
import ReportsPage from "@/pages/Reports";
import ReportEditPage from "@/pages/ReportEdit";
import ReportViewPage from "@/pages/ReportView";
import ForgotPasswordPage from "@/pages/ForgotPassword";
import ResetPasswordPage from "@/pages/ResetPassword";
import AdminUsersPage from "@/pages/AdminUsers";
import AdminReportsPage from "@/pages/AdminReports";
import TimesheetEditor from "@/pages/TimesheetEditor";

const Protected = ({ children }) => {
    const { user } = useAuth();
    if (user === null)
        return (
            <div className="min-h-screen flex items-center justify-center brutal-mono uppercase text-[11px] tracking-brutal opacity-60">
                Loading…
            </div>
        );
    if (user === false) return <Navigate to="/login" replace />;
    return children;
};

const NewReportRedirect = () => {
    // Reports list also creates from the "New Report" button; this route just
    // sends the user there.
    return <Navigate to="/reports" replace />;
};

function App() {
    return (
        <div className="App bg-paper text-ink">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                        <Route path="/reset-password" element={<ResetPasswordPage />} />
                        <Route
                            path="/reports"
                            element={
                                <Protected>
                                    <ReportsPage />
                                </Protected>
                            }
                        />
                        <Route
                            path="/reports/new"
                            element={
                                <Protected>
                                    <NewReportRedirect />
                                </Protected>
                            }
                        />
                        <Route
                            path="/reports/:id"
                            element={
                                <Protected>
                                    <ReportViewPage />
                                </Protected>
                            }
                        />
                        <Route
                            path="/reports/:id/edit"
                            element={
                                <Protected>
                                    <ReportEditPage />
                                </Protected>
                            }
                        />
                        <Route path="/" element={<Navigate to="/reports" replace />} />
                        <Route
                            path="/timesheets/:id"
                            element={
                                <Protected>
                                    <TimesheetEditor readOnly />
                                </Protected>
                            }
                        />
                        <Route
                            path="/timesheets/:id/edit"
                            element={
                                <Protected>
                                    <TimesheetEditor />
                                </Protected>
                            }
                        />
                        <Route
                            path="/admin/users"
                            element={
                                <Protected>
                                    <AdminUsersPage />
                                </Protected>
                            }
                        />
                        <Route
                            path="/admin/reports"
                            element={
                                <Protected>
                                    <AdminReportsPage />
                                </Protected>
                            }
                        />
                        <Route
                            path="/admin"
                            element={<Navigate to="/admin/users" replace />}
                        />
                        <Route path="*" element={<Navigate to="/reports" replace />} />
                    </Routes>
                    <Toaster
                        position="top-right"
                        richColors
                        closeButton
                        toastOptions={{ duration: 2000 }}
                    />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
